import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import BottomNav, { NAV_BAR_SPACER } from '@coeldery/bottom-nav';
import AppShell from './AppShell';
import { NAV_TABS } from '../nav/tabs';
import { useAuth } from '../auth/AuthContext';

/**
 * 會員區外殼：頂欄（AppShell）＋ 內容（`<Outlet/>`）＋ **底部 5 個 tab**（`@coeldery/bottom-nav`）。
 * ⚠️ 未登入 → 跳 `/login`。
 */
export default function MemberLayout() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <AppShell title={t('member_title')}>
        <div className="p-6" />
      </AppShell>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  const active = NAV_TABS.find((tb) => pathname.startsWith(tb.path))?.id ?? NAV_TABS[0].id;

  return (
    <AppShell title={t('member_title')}>
      <div className="p-4">
        <Outlet />
      </div>
      <div style={NAV_BAR_SPACER} aria-hidden="true" />
      <BottomNav
        tabs={NAV_TABS}
        activeId={active}
        onSelect={(id) => {
          const tb = NAV_TABS.find((x) => x.id === id);
          if (tb) nav(tb.path);
        }}
      />
    </AppShell>
  );
}
